import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { actions } from 'reducers';

const mapStateToProps = state => ({
  isLoggingIn: state.auth.status === 'AWAITING_RESPONSE',
  isLoggedIn: state.auth.status === 'LOGGED_IN',
  invalidLogin: state.auth.invalidLogin
});

const mapDispatchToProps = { login: actions.auth.open };

const handlers = {
  onSubmit: ({ login }) => ({ email, password }) => login({ email, password })
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers(handlers)
);



// WEBPACK FOOTER //
// ./src/components/login/login-form/enhance.js